"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchRequisitionPayloadDtoToJSON = exports.PatchRequisitionPayloadDtoFromJSONTyped = exports.PatchRequisitionPayloadDtoFromJSON = exports.instanceOfPatchRequisitionPayloadDto = void 0;
var runtime_1 = require("../runtime");
var IndicatedGene_1 = require("./IndicatedGene");
var PatchRQInstitutionBillingDto_1 = require("./PatchRQInstitutionBillingDto");
var PatchRQInsuranceBillingDto_1 = require("./PatchRQInsuranceBillingDto");
var PatchRQOrderingClinicianDto_1 = require("./PatchRQOrderingClinicianDto");
var PatchRQRequisitionConceptDto_1 = require("./PatchRQRequisitionConceptDto");
var PaymentMethodsEnum_1 = require("./PaymentMethodsEnum");
var ReflexDetailsPayloadDto_1 = require("./ReflexDetailsPayloadDto");
var RequisitionReqtype_1 = require("./RequisitionReqtype");
var RequisitionSpecialType_1 = require("./RequisitionSpecialType");
/**
 * Check if a given object implements the PatchRequisitionPayloadDto interface.
 */
function instanceOfPatchRequisitionPayloadDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfPatchRequisitionPayloadDto = instanceOfPatchRequisitionPayloadDto;
function PatchRequisitionPayloadDtoFromJSON(json) {
    return PatchRequisitionPayloadDtoFromJSONTyped(json, false);
}
exports.PatchRequisitionPayloadDtoFromJSON = PatchRequisitionPayloadDtoFromJSON;
function PatchRequisitionPayloadDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentType': !(0, runtime_1.exists)(json, 'paymentType') ? undefined : (0, PaymentMethodsEnum_1.PaymentMethodsEnumFromJSON)(json['paymentType']),
        'billingEmail': !(0, runtime_1.exists)(json, 'billingEmail') ? undefined : json['billingEmail'],
        'reqtype': !(0, runtime_1.exists)(json, 'reqtype') ? undefined : (0, RequisitionReqtype_1.RequisitionReqtypeFromJSON)(json['reqtype']),
        'specialTypes': !(0, runtime_1.exists)(json, 'specialTypes') ? undefined : (json['specialTypes'].map(RequisitionSpecialType_1.RequisitionSpecialTypeFromJSON)),
        'accessionDate': !(0, runtime_1.exists)(json, 'accessionDate') ? undefined : json['accessionDate'],
        'addedGenesIds': !(0, runtime_1.exists)(json, 'addedGenesIds') ? undefined : (json['addedGenesIds'].map(IndicatedGene_1.IndicatedGeneFromJSON)),
        'nipsEstimatedDueDate': !(0, runtime_1.exists)(json, 'nipsEstimatedDueDate') ? undefined : json['nipsEstimatedDueDate'],
        'collectionDate': !(0, runtime_1.exists)(json, 'collectionDate') ? undefined : json['collectionDate'],
        'concepts': !(0, runtime_1.exists)(json, 'concepts') ? undefined : (json['concepts'].map(PatchRQRequisitionConceptDto_1.PatchRQRequisitionConceptDtoFromJSON)),
        'currentEstimatedReportDate': !(0, runtime_1.exists)(json, 'currentEstimatedReportDate') ? undefined : json['currentEstimatedReportDate'],
        'icd10Codes': !(0, runtime_1.exists)(json, 'icd10Codes') ? undefined : json['icd10Codes'],
        'insuranceBilling': !(0, runtime_1.exists)(json, 'insuranceBilling') ? undefined : (json['insuranceBilling'].map(PatchRQInsuranceBillingDto_1.PatchRQInsuranceBillingDtoFromJSON)),
        'institutionBilling': !(0, runtime_1.exists)(json, 'institutionBilling') ? undefined : (0, PatchRQInstitutionBillingDto_1.PatchRQInstitutionBillingDtoFromJSON)(json['institutionBilling']),
        'invitaeStudyCode': !(0, runtime_1.exists)(json, 'invitaeStudyCode') ? undefined : json['invitaeStudyCode'],
        'orderingClinician': !(0, runtime_1.exists)(json, 'orderingClinician') ? undefined : (0, PatchRQOrderingClinicianDto_1.PatchRQOrderingClinicianDtoFromJSON)(json['orderingClinician']),
        'pcmEdtaAccessionDate': !(0, runtime_1.exists)(json, 'pcmEdtaAccessionDate') ? undefined : json['pcmEdtaAccessionDate'],
        'pcmEdtaCollectionDate': !(0, runtime_1.exists)(json, 'pcmEdtaCollectionDate') ? undefined : json['pcmEdtaCollectionDate'],
        'pcmFfpeAccessionDate': !(0, runtime_1.exists)(json, 'pcmFfpeAccessionDate') ? undefined : json['pcmFfpeAccessionDate'],
        'pcmFfpeCollectionDate': !(0, runtime_1.exists)(json, 'pcmFfpeCollectionDate') ? undefined : json['pcmFfpeCollectionDate'],
        'physicianSignDate': !(0, runtime_1.exists)(json, 'physicianSignDate') ? undefined : json['physicianSignDate'],
        'positiveFinding': !(0, runtime_1.exists)(json, 'positiveFinding') ? undefined : json['positiveFinding'],
        'primaryIndication': !(0, runtime_1.exists)(json, 'primaryIndication') ? undefined : json['primaryIndication'],
        'reflexDetails': !(0, runtime_1.exists)(json, 'reflexDetails') ? undefined : (0, ReflexDetailsPayloadDto_1.ReflexDetailsPayloadDtoFromJSON)(json['reflexDetails']),
        'reviewedAt': !(0, runtime_1.exists)(json, 'reviewedAt') ? undefined : json['reviewedAt'],
    };
}
exports.PatchRequisitionPayloadDtoFromJSONTyped = PatchRequisitionPayloadDtoFromJSONTyped;
function PatchRequisitionPayloadDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paymentType': (0, PaymentMethodsEnum_1.PaymentMethodsEnumToJSON)(value.paymentType),
        'billingEmail': value.billingEmail,
        'reqtype': (0, RequisitionReqtype_1.RequisitionReqtypeToJSON)(value.reqtype),
        'specialTypes': value.specialTypes === undefined ? undefined : (value.specialTypes.map(RequisitionSpecialType_1.RequisitionSpecialTypeToJSON)),
        'accessionDate': value.accessionDate,
        'addedGenesIds': value.addedGenesIds === undefined ? undefined : (value.addedGenesIds.map(IndicatedGene_1.IndicatedGeneToJSON)),
        'nipsEstimatedDueDate': value.nipsEstimatedDueDate,
        'collectionDate': value.collectionDate,
        'concepts': value.concepts === undefined ? undefined : (value.concepts.map(PatchRQRequisitionConceptDto_1.PatchRQRequisitionConceptDtoToJSON)),
        'currentEstimatedReportDate': value.currentEstimatedReportDate,
        'icd10Codes': value.icd10Codes,
        'insuranceBilling': value.insuranceBilling === undefined ? undefined : (value.insuranceBilling.map(PatchRQInsuranceBillingDto_1.PatchRQInsuranceBillingDtoToJSON)),
        'institutionBilling': (0, PatchRQInstitutionBillingDto_1.PatchRQInstitutionBillingDtoToJSON)(value.institutionBilling),
        'invitaeStudyCode': value.invitaeStudyCode,
        'orderingClinician': (0, PatchRQOrderingClinicianDto_1.PatchRQOrderingClinicianDtoToJSON)(value.orderingClinician),
        'pcmEdtaAccessionDate': value.pcmEdtaAccessionDate,
        'pcmEdtaCollectionDate': value.pcmEdtaCollectionDate,
        'pcmFfpeAccessionDate': value.pcmFfpeAccessionDate,
        'pcmFfpeCollectionDate': value.pcmFfpeCollectionDate,
        'physicianSignDate': value.physicianSignDate,
        'positiveFinding': value.positiveFinding,
        'primaryIndication': value.primaryIndication,
        'reflexDetails': (0, ReflexDetailsPayloadDto_1.ReflexDetailsPayloadDtoToJSON)(value.reflexDetails),
        'reviewedAt': value.reviewedAt,
    };
}
exports.PatchRequisitionPayloadDtoToJSON = PatchRequisitionPayloadDtoToJSON;
